class BlogArticle extends HTMLElement {
  constructor() {
    super();
    this.handleShowMore = this.handleShowMore.bind(this);
  }

  connectedCallback() {
    this.articleContent = this.querySelector(".bosArticleContent");
    this.showMore = this.querySelector(".bosArticleLoadMoreButton");
    if (this.showMore) {
      this.showMore.addEventListener("click", this.handleShowMore);
    }
  }

  handleShowMore() {
    const isExpanded = this.articleContent?.classList.toggle(
      "bosArticleContentShowAll",
    );
    if (this.showMore) {
      this.showMore.textContent = isExpanded ? "Show Less" : "Show More";
    }
  }
}

if (!customElements.get("blog-article")) {
  customElements.define("blog-article", BlogArticle);
}
